import { ClockCircleOutlined, EditOutlined, GoogleCircleFilled, InfoCircleOutlined, PhoneOutlined } from '@ant-design/icons';
import { Tag, Button, Divider, Form, message, Modal, Tabs, Alert, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { PhoneGroupMassive } from '../../../components/model/location/contact/phone/Massive/PhoneGroupMassive';
import { WebGroupMassive } from '../../../components/model/location/contact/web/Massive/WebGroupMassive';
import { NameGroupMassive } from '../../../components/model/location/info/name/Massive/NameGroupMassive';
import { DescriptionGroupMassive } from '../../../components/model/location/info/description/Massive/DescriptionGroupMassive';
import { CategoriesMassive } from '../../../components/model/location/info/category/massive/CategoriesMassive';
import { NormalScheduleMassive } from '../../../components/model/location/hours/NormalScheduleMassive';
import { SpecialHoursMassive } from '../../../components/model/location/hours/SpecialHoursMassive';
import { DrawerPanelTitle, modalPanelStyles } from '../../common/Drawers/DrawerPanelTitle';

export const GoogleEditPanel = ({
	selectedRowKeys,
	visible,
	onFinish,
	onCancel,
}: any) => {

	const { t } = useTranslation();
	const onFormCancel = async (values: any) => {
		onCancel();
	}
	
	return (
		<Modal
			open={visible}
			footer={null}
			onCancel={onFormCancel}
			width={'60%'}
			centered
			className={modalPanelStyles.className}
			bodyStyle={{ ...modalPanelStyles.bodyStyle, minHeight: '90vh' }}
			title={
				<DrawerPanelTitle
					title={<><EditOutlined/> {t('locals.page.management.modals.edit.title')}</>}
					locationsCount={selectedRowKeys.length}
					massive
				/>
			}
		>
			<Tabs defaultActiveKey="1" type="line" style={{ width: '100%' }}>
				
				<Tabs.TabPane tab={<span className='title-tabPane'>{t('dictionary.schedule')}</span>} key="1">
					<NormalScheduleMassive locationsIds={selectedRowKeys} onFinish={onFinish} onCancel={onCancel}/>
				</Tabs.TabPane>

				<Tabs.TabPane tab={<span className='title-tabPane'>Festivos</span>} key="2">
					<SpecialHoursMassive locationsIds={selectedRowKeys} onFinish={onFinish} onCancel={onCancel}/>
				</Tabs.TabPane>

				<Tabs.TabPane tab={<span className='title-tabPane'>{t('dictionary.businessInformation')}</span>} key="3">
					<NameGroupMassive locationsIds={selectedRowKeys} />					
					<DescriptionGroupMassive locationsIds={selectedRowKeys} />
				</Tabs.TabPane>

				<Tabs.TabPane tab={<span className='title-tabPane'>{t('dictionary.contactInformation')}</span>} key="4">
					<PhoneGroupMassive primaryPhone={''} additionalPhones={[]} locationsIds={selectedRowKeys} />
					<WebGroupMassive locationsIds={selectedRowKeys} />
				</Tabs.TabPane>

				<Tabs.TabPane tab={<span className='title-tabPane'>{t('dictionary.category')}</span>} key="5">
					<CategoriesMassive primaryCategory={''} additionalCategories={[]} locationsIds={selectedRowKeys} />
				</Tabs.TabPane>

				
			</Tabs>

		</Modal>
	)
}
